import IExtension from "./IExtension";
import {Naja} from "naja";

/**
 * Fix modal component opened from offcanvas order
 */
export default class ModalInOffcanvasExtension implements IExtension {
    private placeholders = new WeakMap<HTMLElement, Comment>();

    initialize(naja: Naja): void {
        document.addEventListener('show.bs.modal', event => this.handleShow(event));
        document.addEventListener('shown.bs.modal', event => this.handleShown(event));
        document.addEventListener('hidden.bs.modal', event => this.handleHidden(event));
    }

    private handleShow(event: Event): void {
        const modal = event.target;
        if (!(modal instanceof HTMLElement) || !modal.parentElement?.closest('.offcanvas')) {
            return;
        }

        const placeholder = document.createComment('modal-placeholder');
        modal.replaceWith(placeholder);
        document.body.append(modal);
        this.placeholders.set(modal, placeholder);
    }

    private handleShown(event: Event): void {
        const modal = event.target;
        if (modal instanceof HTMLElement && this.placeholders.has(modal)) {
            modal.focus();
        }
    }

    private handleHidden(event: Event): void {
        const modal = event.target;
        if (!(modal instanceof HTMLElement)) {
            return;
        }

        const placeholder = this.placeholders.get(modal);
        if (!placeholder) {
            return;
        }
        this.placeholders.delete(modal);

        if (placeholder.isConnected) {
            placeholder.replaceWith(modal);
        } else {
            modal.remove();
        }
    }
}
